import { Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { EditIcon, TrashIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import { getMenuPermissions } from 'Helper/getMenuPermissions';
import ButtonOutline from 'UiKit/button/buttonOutline';

import useOpenDeleteModal from 'View/user/hooks/useOpenDeleteModal';

const ActionButton = ({ value, rawData }) => {
  const accessPermission = getMenuPermissions('master-data', 'user');

  const navigate = useNavigate();

  const { onOpenDeleteModal } = useOpenDeleteModal();

  return (
    <Flex gap="10px" height={'100%'} alignItems={'center'}>
      <Condition statement={accessPermission?.isCanDelete && !rawData?.isImmutable && rawData.isActive}>
        <ButtonOutline
          borderWidth="1.5px"
          color="var(--color-error50)"
          minWidth="42px"
          width="42px"
          height="42px"
          onClick={() => {
            onOpenDeleteModal(value);
          }}
          data-testid="delete-button-user-list"
        >
          <TrashIcon color="var(--color-error50)" size="18px" />
        </ButtonOutline>
      </Condition>
      <Condition statement={accessPermission?.isCanEdit && !rawData?.isImmutable && rawData.isActive && !rawData?.role.isHost}>
        <ButtonOutline
          borderWidth="1.5px"
          color="var(--color-semantic-black)"
          minWidth="42px"
          width="42px"
          height="42px"
          onClick={() => {
            navigate(`/master-data/user/upsert/${value}?viewType=upsert`);
          }}
          data-testid="edit-button-user-list"
        >
          <EditIcon color="var(--color-semantic-black)" size="18px" />
        </ButtonOutline>
      </Condition>
    </Flex>
  );
};

export default ActionButton;
